module.exports = {"name":"--pf-c-background-image--BackgroundImage-2x","value":"url(assets/images/pfbg_576@2x.jpg)","var":"var(--pf-c-background-image--BackgroundImage-2x)"}
